<div class="transport-options-editor no-field-space">
    <sc-padding>
        <form [formGroup]="optionFormGroup">
            <mat-slide-toggle formControlName="amountOfPallettesMandatory" name="amountOfPallettesMandatory">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.amount-of-pallettes-mandatory"></sc-dictionary-label>
            </mat-slide-toggle>
            <sc-content-spacer vertical></sc-content-spacer>
            <mat-slide-toggle formControlName="amountOfBoxesMandatory" name="amountOfBoxesMandatory">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.amount-of-boxes-mandatory"></sc-dictionary-label>
            </mat-slide-toggle>
            <sc-content-spacer vertical></sc-content-spacer>
            <mat-slide-toggle formControlName="amountInKilogrammMandatory" name="amountInKilogrammMandatory">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.amount-in-kilogramm-mandatory"></sc-dictionary-label>
            </mat-slide-toggle>
            <sc-content-spacer vertical></sc-content-spacer>
            <mat-slide-toggle formControlName="amountInLiterMandatory" name="amountInLiterMandatory">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.amount-in-liter-mandatory"></sc-dictionary-label>
            </mat-slide-toggle>
            <sc-content-spacer vertical></sc-content-spacer>
            <mat-slide-toggle formControlName="amountOthersMandatory" name="amountOthersMandatory">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.amount-others-mandatory"></sc-dictionary-label>
            </mat-slide-toggle>
            <sc-content-spacer vertical [double]="true"></sc-content-spacer>
            <mat-slide-toggle formControlName="amountMandatoryInTerminal" name="amountMandatoryInTerminal">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.amount-mandatory-in-terminal"></sc-dictionary-label>
            </mat-slide-toggle>
            <sc-content-spacer vertical></sc-content-spacer>
            <mat-slide-toggle formControlName="amountMandatoryInTime" name="amountMandatoryInTime">
                <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.amount-mandatory-in-time"></sc-dictionary-label>
            </mat-slide-toggle>
        </form>
    </sc-padding>
</div>
